import React, { FC } from 'react';
import { usePublicJobDetailDataQuery } from '../../hooks';
import { isNull } from '../../../../../predicates/type';
import { PublicJobDetailBox } from '../PublicJobDetailBox';
import { Typography } from '../../../../../components/Typography';
import { FlexGrid, FlexGridColumn } from '../../../../../components/FlexGrid';
import { PublicJobDetailEmployerDataItem } from './PublicJobDetailEmployerDataItem';
import { MapMarker } from '../../../../../components/Icons/MapMarker';
import { isBadOrEmptyString } from '../../../../../predicates/string';
import { BriefCase } from '../../../../../components/Icons/BriefCase';
import { PaddingBox } from '../../../../../components/PaddingBox';
import { RouteLink } from '../../../../../components/RouteLink';

export const PublicJobDetailEmployer: FC = () => {
	const {
		data: { employer },
	} = usePublicJobDetailDataQuery();

	if (isNull(employer)) return null;

	const {
		isPublicEmployer,
		url,
		employerOrganizationName,
		employerOrganizationLogoUrl,
		employerFormattedAddress,
		employerJobsCount,
	} = employer;

	return (
		<PublicJobDetailBox>
			<PaddingBox bottomSmall>
				<RouteLink
					href={isPublicEmployer ? url : '#'}
					hasColor={false}
				>
					<Typography bold>{employerOrganizationName}</Typography>
				</RouteLink>
			</PaddingBox>
			<FlexGrid
				gap='small'
				center
			>
				<FlexGridColumn grow>
					<PublicJobDetailEmployerDataItem
						icon={MapMarker}
						value={employerFormattedAddress}
					/>
					{!isBadOrEmptyString(employerJobsCount) && (
						<PaddingBox topTiny>
							<PublicJobDetailEmployerDataItem
								icon={BriefCase}
								value={employerJobsCount}
							/>
						</PaddingBox>
					)}
				</FlexGridColumn>
				{!isBadOrEmptyString(employerOrganizationLogoUrl) && (
					<FlexGridColumn
						noShrink
						noGrow
						flexBasis='64px'
					>
						<img
							src={employerOrganizationLogoUrl}
							alt='employer organization logo url'
						/>
					</FlexGridColumn>
				)}
			</FlexGrid>
		</PublicJobDetailBox>
	);
};
